import { propertyQueryKeys as e } from "../properties/usePropertiesQueryKeys.mjs";
import { housekeepingQueryKeys as t } from "./useHousekeepingQueryKeys.mjs";
import { patchBoardRoom as n } from "./patchBoardRoom.mjs";
//#region src/housekeeping/invalidateHousekeeping.ts
var r = (n, r, i) => {
	n.invalidateQueries({ queryKey: t.board() }), n.invalidateQueries({ queryKey: t.attention() });
	for (let t of i) n.invalidateQueries({ queryKey: e.room(t) });
	n.invalidateQueries({ queryKey: e.property(r) });
}, i = (e, i, a) => {
	for (let r of a) e.setQueriesData({ queryKey: t.board(i) }, (e) => n(e, r));
	r(e, i, a.map((e) => e.unit_id));
};
//#endregion
export { i as applyHousekeepingWrite, r as invalidateHousekeeping };
